import type { NewsEntity } from '@ipen-portal/ipen-entity-model';

export const getNewsType = (
  entity: NewsEntity,
): 'compass' | 'connect' | 'external' | 'portal' => {
  const { url } = entity.spec.link;

  if (url.startsWith('https://compass')) {
    return 'compass';
  }

  if (url.startsWith('https://connect')) {
    return 'connect';
  }

  if (url.startsWith('/')) {
    return 'portal';
  }

  return 'external';
};
